<template>
  <section class="v1-providers__amount" :data-testid="testId">
    <p class="v1-providers__amount-label">{{ label }}</p>
    <p class="v1-providers__amount-value">{{ amount }}</p>
    <p v-if="nextPayment" class="v1-providers__next-payment" :data-testid="nextPaymentTestId">
      {{ nextPayment }}
    </p>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ProviderAmountSummary",
  props: {
    label: { type: String, default: "" },
    amount: { type: String, default: "" },
    nextPayment: { type: String, default: "" },
    testId: { type: String, default: "providers-amount" },
    nextPaymentTestId: { type: String, default: "providers-next-payment" },
  },
});
</script>

<style scoped>
.v1-providers__amount {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.v1-providers__amount-label {
  margin: 0;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.5px;
  color: var(--pj-color-brand-gray-550, #74756f);
}

.v1-providers__amount-value {
  margin: 0;
  font-family: "Inter", sans-serif;
  font-size: 40px;
  font-weight: 600;
  line-height: 52px;
  letter-spacing: -0.5px;
  color: var(--pj-color-brand-gray-850, #222926);
}

.v1-providers__next-payment {
  margin: 0;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: var(--pj-color-brand-gray-550, #74756f);
}
</style>
